import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import { Input, TextArea, Ref } from 'semantic-ui-react'
import StaticInput from './StaticInput'

import './TextInput.css'

class TextInput extends React.Component {

  constructor(props) {

    // Properties
    super(props)

    // State
    this.state = {
      value: props.value || '',
      fieldRef: null,
      hasSuggestionsVisible: (props.style && props.style.autoFocus && true) || false,
      willBlur: false
    }

    // Bind events
    this.onChange = this.onChange.bind(this)
    this.onFocus = this.onFocus.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.onClick = this.onClick.bind(this)
    this.onClickSuggestion = this.onClickSuggestion.bind(this)
    this.setRef = this.setRef.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    // Bubble local change to parent
    if (prevState.value !== this.state.value) {
      if (_.isFunction(this.props.onChange)) {
        this.props.onChange(this.state.value)
      }
    }

    // Bubble parent change to local
    if (prevProps.value !== this.props.value) {
      this.setState({
        value: this.props.value
      })
    }

    // Bubble ref change to parent
    if (
      prevState.fieldRef !== this.state.fieldRef
      &&
      _.isFunction(this.props.fieldRef)
    ) {
      this.props.fieldRef(this.state.fieldRef)
    }
  }

  onChange(event, data) {
    const value = data.value
    this.setState({
      value,
      hasSuggestionsVisible: false
    })
  }

  onFocus() {
    this.setState({
      willBlur: false,
      hasSuggestionsVisible: true
    })
  }

  onBlur() {
    this.setState({
      willBlur: true
    })
    setTimeout(
      () => {
        this.setState((prevState, props) => (_.extend(
          {
            willBlur: false
          },
          prevState.willBlur
            ? {
                hasSuggestionsVisible: false
              }
            : {}
        )))
      },
      250
    )
  }

  onClick() {
    this.setState({
      hasSuggestionsVisible: true
    })
  }

  onClickSuggestion(value) {
    return () => {
      this.state.fieldRef.focus()
      this.setState({
        value,
        hasSuggestionsVisible: false
      })
    }
  }

  setRef(divRef) {
    const fieldRef = divRef.getElementsByTagName('input')[0]
    this.setState({
      fieldRef
    })
  }

  render() {
    const { label, value, onChange, error, multiline, ...props } = this.props
    const component = (
      <Ref innerRef={this.setRef}>
        {
          multiline
            ? <TextArea
                rows={3}
                autoHeight={true}
                value={this.state.value}
                onChange={this.onChange}
                {...props}
              />
            : <Input
                type='text'
                value={this.state.value}
                onChange={this.onChange}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                onClick={this.onClick}
                loading={this.props.suggestionsLoading}
                {...props}
              />
        }
      </Ref>
    )
    return (
      <StaticInput
        label={label}
        content={
          !_.isUndefined(this.props.suggestions)
            ? <div className='input-suggestions'>
                { component }
                {
                  <div
                    className='menu'
                    style={
                      this.state.hasSuggestionsVisible && !this.props.suggestionsLoading
                        ? {}
                        : { display: 'none' }
                    }
                  >
                    {
                      _.isArray(this.props.suggestions) && _.size(this.props.suggestions) > 0
                        ? _.map(
                            _.union(this.props.suggestions),
                            (suggestion) => (
                              <div
                                key={suggestion}
                                className='item'
                                onClick={this.onClickSuggestion(suggestion)}
                              >
                                {suggestion}
                              </div>
                            )
                          )
                        : <div
                            className='item empty'
                          >
                            Rien à afficher.
                          </div>
                    }
                  </div>
                }
              </div>
            : component
        }
        error={error}
      />
    )
  }
}

TextInput.propTypes = {
  label: PropTypes.string, // if missing, rendered without Form structure
  value: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  multiline: PropTypes.bool,
  fieldRef: PropTypes.func,
  suggestions: PropTypes.array,
  suggestionsLoading: PropTypes.bool
}

export default TextInput



// WEBPACK FOOTER //
// ./src/components/elements/forms/TextInput.js